import React from 'react';

// constants
import { TWO_COL_GRID_SIZES } from 'constants/grids';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormValuesModel } from '..';
import { useFormikContext } from 'formik';

// components
import DivAlignCenter from 'components/Additional/DivAlignCenter';
import TrueFalseSelect from '../../../../FormComponents/SelectInputs/TrueFalseSelect';
import AreYouPepTooltip from '../../../../../Tooltips/TemplateTooltips/AreYouPepTooltip';
import { FormField, SectionIntro, FormInputTextArea, Col, Row } from '@ui';

interface IProps {
  mainSectionTooltip?: React.ReactNode;
}

const InnerForm = ({ mainSectionTooltip }: IProps) => {
  const { t } = useTranslation('onboarding');
  const { values } = useFormikContext<FormValuesModel>();

  return (
    <>
      <SectionIntro
        title={
          <>
            {t('identification.title')} {mainSectionTooltip}
          </>
        }
        description={t('identification.description_individual')}
      />

      <Row gutter={[16, 16]}>
        <Col {...TWO_COL_GRID_SIZES}>
          <FormField
            label={
              <DivAlignCenter>
                {t('identification.form_fields.individual.is_pep')}{' '}
                <AreYouPepTooltip />
              </DivAlignCenter>
            }
            name="isPEP"
            component={TrueFalseSelect}
          />
        </Col>

        <Col {...TWO_COL_GRID_SIZES}>
          {values.isPEP && (
            <FormField
              label={t('identification.form_fields.individual.pep_information')}
              name="pepInformation"
              component={FormInputTextArea}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default InnerForm;
